<template>
  <div class="navigationSeventh">
    <div class="navigationSevenths">
      <div class="nav">
        <div class="nav_t">
          <div class="nav_l">
            <span>{{ currentDate }}</span>
            <span class="q">用心 · 用情 · 用力做教育!</span>
          </div>
          <div class="nav_r">24小时热线：400-663-2666</div>
        </div>
        <div class="b">
          <div class="l"></div>
          <div class="r">
            <div>首页
              <div class="line"></div>
            </div>
            <div>学校概况</div>
            <div>招生简章</div>
            <div>项目介绍</div>
            <div>专业设置</div>
            <div>在线学习</div>
            <div>报考指南</div>
            <div>网上报名</div>
            <div>联系我们</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginOut } from "@/api/user";
import { Know } from "@/api/know";

const know = new Know();
import Bus from "@/api/bus";
import Vue from "vue";
import {
  setReady,
  getToken,
  getInfo,
  getDomainLogo,
  getDomain,
} from "@/api/cookies";
export default {
  components: {},
  data() {
    return {
      userInfo: null,
    };
  },

  async created() {
    this.userInfo = getInfo();
    this.domainInfo = getDomain();
    this.logo = getDomainLogo();
    this.userId = localStorage.getItem("userId");
    this.token = getToken();
    this.userInfos = getInfo();
    this.getTodayDate();
  },

  methods: {
    getTodayDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      // 拼接年月日
      this.currentDate = `${year}-${month}-${day}`;
    },
    open() {
      window.open("http://gxhh.unzs.com", "_blank");
    },

    /* 菜单切换 */
    handleSelect(key, keyPath) {
      if (key == "/0" || key == "/1" || key == "/2") {
        return;
      }
      const userInfo = getInfo();
      for (const item of this.data.chil) {
        if (key == item.path) {
          this.data.name = item.name;
          this.data.path = item.path;
          break;
        }
      }
      if (
        !userInfo &&
        (key == "/partnerPage/my/myInfo" || key == "/partnerPage/mycurriculum")
      ) {
        this.$notify({
          title: "提醒",
          message: "请您先登录~",
          offset: 100,
        });
        // Vue.prototype.goLoginView(false)
        return;
      }

      const routeUrl = this.$router.resolve({
        path: key,
      });
      window.open(key, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.navigationSeventh {
  position: relative;
  height: 133px;

  .navigationSevenths {
    width: 100%;
    height: 133px;
    background: linear-gradient(90deg, #0073ff 0%, #0057c9 100%);
    border-radius: 0px 0px 0px 0px;
    position: fixed;
    z-index: 9999;
    padding: 15px 0;

    .nav {
      width: 1400px;
      margin: 0 auto;

      .nav_t {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .nav_l {
          span {
            font-family: MiSans, MiSans;
            font-weight: 500;
            font-size: 13px;
            color: #FFFFFF;
          }

          .q {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 13px;
            color: #FFFFFF;
            margin-left: 16px;
          }
        }

        .nav_r {
          font-family: MiSans, MiSans;
          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
        }
      }

      .b {
        margin-top: 15px;
        height: 68px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .l {
          width: 453px;
          height: 68px;
          border-radius: 0px 0px 0px 0px;
        }

        .r {
          width: 850px;
          display: flex;
          align-items: center;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;

          >div {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 38px;

            .line {
              position: absolute;
              bottom: -6px;
              width: 20px;
              height: 4px;
              background: #FFFFFF;
              border-radius: 3px 3px 3px 3px;
            }
            &:last-child{
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>
